import { validateLogisticsAgainstEwayBill } from './soLogistics';

const RO_LOGISTICS_RETURN_TYPES = new Set([
  'RTO',
  'PARTIAL_RTO',
  'BUYER_STOCK_TRANSFER',
  'OTHER',
  'QC_STOCK_CORRECTION',
  'REFURBISH_INTERNAL',
  'REFURBISH_EXTERNAL'
]);

/** Product (2026-07-22): EWB always before dispatch for RTO / Partial RTO / RTB. */
const EWB_REQUIRED_BEFORE_DISPATCH_TYPES = new Set(['RTO', 'PARTIAL_RTO', 'BUYER_STOCK_TRANSFER']);

/** Return types in TASK-4132 returns scope (RTO, Partial RTO, RTB-style flows). */
export const isRoLogisticsScope = (returnType) => RO_LOGISTICS_RETURN_TYPES.has(returnType);

export const isRoEwbRequiredBeforeDispatch = (returnType) => EWB_REQUIRED_BEFORE_DISPATCH_TYPES.has(returnType);

export const getActiveRoEwayBill = (shippingDocuments) =>
  shippingDocuments?.find(
    (doc) => ['EWAY_BILL_PART_A', 'EWAY_BILL_PART_AB'].includes(doc?.document_type) && doc?.status === 'ACTIVE'
  ) ?? null;

/** Vehicle number is optional on the return-order Mark as Dispatch modal. */
export const isRoDispatchVehicleMandatory = () => false;

/** Delivery: vehicle + transporter mandatory for all in-scope return types. */
export const isRoDeliveryLogisticsMandatory = (returnType) => isRoLogisticsScope(returnType);

export const validateRoLogisticsAgainstEwayBill = ({
  transporterName,
  ewayBill,
  returnType,
  skipTransporterValidation = false,
  transporters
}) => {
  if (isRoEwbRequiredBeforeDispatch(returnType) && !ewayBill?.document_number) {
    return 'E-Way Bill must be generated before dispatch/delivery for this return order.';
  }

  return validateLogisticsAgainstEwayBill({
    transporterName,
    ewayBillDetails: ewayBill
      ? {
          document_number: ewayBill.document_number,
          transporter_name: ewayBill.transporter_name
        }
      : null,
    skipTransporterValidation,
    transporters
  });
};
